// extracted by mini-css-extract-plugin
export var compactFilters = "_d9-4";
export var detailImage = "_d9-1";
export var dropdownContainer = "_d9-2";
export var imageContainer = "_d9-0";
export var selectedCard = "_d9-3";